import { Box, Flex, Text, Heading, Link as ChakraLink } from "@chakra-ui/react";

interface SessionProps {
  id: string;
  title: string;
  content: string;
  day: string;
  link?: string;
}

export default function Session({
  id,
  title,
  content,
  day,
  link,
}: SessionProps) {
  return (
    <Box borderRadius="md" mb={4}>
      <Heading as="h3" size="md" mb={2}>
        {link ? (
          <ChakraLink href={link} color="blue.600">
            {title}
          </ChakraLink>
        ) : (
          title
        )}
      </Heading>
      <Text whiteSpace="pre-wrap" fontSize={13}>
        {content}
      </Text>
    </Box>
  );
}
